import * as React from "react";

function SvgLabormarket(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.97 20.96"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M.01 20.97V7.52l2.32-2.89L4.8 7.52v5.24h1.37V-.03h4.93v12.79h.91V6.38h5.13v10.14h1.38v-15h5.49v19.45h-24z" />
    </svg>
  );
}

const MemoSvgLabormarket = React.memo(SvgLabormarket);
export default MemoSvgLabormarket;
